// 消息对话
const conversationList = r => require.ensure(
  [],
  () => r(require('@/components/recommend/common/reply-list')),
  'conversationList'
)

export default [
  // 文章内容
  {
    path: '/conversation/list',
    name: 'conversationList',
    component: conversationList
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/conversation.js